(function () {
  if (customElements.get('faqs-item')) return;

  class FAQs extends HTMLElement {
    constructor() {
      super();

      this.filter = this.querySelector('#haloFAQsFilter');

      if (this.filter) {
        this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
        this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
        this.filterDropdownArrow = this.filterToggle
          ? this.filterToggle.querySelector('[data-dropdown-arrow]')
          : null;

        if (this.filterToggle) {
          this.filterToggle.addEventListener(
            'click',
            this.onClickFilterHandler.bind(this)
          );
        }

        if (this.filterDropdown) {
          this.filterDropdown.querySelectorAll('li .text').forEach((button) => {
            button.addEventListener(
              'click',
              this.onClickFilterButtonHandler.bind(this)
            );
          });

          document.body.addEventListener(
            'click',
            this.onBodyClickEvent.bind(this)
          );
        }
      }

      this.querySelectorAll('.card-header').forEach((header) => {
        header.addEventListener(
          'click',
          this.onClickHeaderButtonHandler.bind(this)
        );
      });
    }

    onClickFilterHandler() {
      if (!this.filterDropdown) return;

      this.filterDropdown.classList.toggle('is-show');

      if (this.filterDropdownArrow) {
        this.filterDropdownArrow.classList.toggle('active');
      }
    }

    onClickFilterButtonHandler(event) {
      const button = event.target.closest('li');
      if (!button || !this.filterDropdown || !this.filterToggle) return;

      if (button.classList.contains('is-active')) return;

      const filterValue = button.getAttribute('data-value');
      const filterText = event.target.innerText;
      const toggleText = this.filterToggle.querySelector('.text');

      if (toggleText) toggleText.innerText = filterText;

      this.filterDropdown.querySelectorAll('li').forEach((item) => {
        item.classList.remove('is-active');
      });

      button.classList.add('is-active');

      this.querySelectorAll('.faqs-paragraph').forEach((paragraph) => {
        if (!filterValue) {
          paragraph.classList.remove('is-hidden', 'is-active');
        } else if (paragraph.id === filterValue) {
          paragraph.classList.remove('is-hidden');
          paragraph.classList.add('is-active');
        } else {
          paragraph.classList.remove('is-active');
          paragraph.classList.add('is-hidden');
        }
      });

      this.filterDropdown.classList.remove('is-show');

      if (this.filterDropdownArrow) {
        this.filterDropdownArrow.classList.remove('active');
      }
    }

    onClickHeaderButtonHandler(event) {
  const header = event.currentTarget;
  const panel = header.nextElementSibling;

  // Homepage aur FAQ page par existing toggle behavior rakhein
  if (!document.body.classList.contains('template-product')) {
    const isCollapsed = header.classList.toggle('collapsed');
    header.setAttribute('aria-expanded', String(!isCollapsed));

    if (panel) {
      panel.style.maxHeight = panel.style.maxHeight
        ? null
        : panel.scrollHeight + 'px';
    }
    return;
  }

  // Product page par ek waqt mein sirf ek FAQ open rakhein
  const shouldOpen = header.classList.contains('collapsed');

  this.querySelectorAll('.card-header').forEach((item) => {
    item.classList.add('collapsed');
    item.setAttribute('aria-expanded', 'false');

    const itemPanel = item.nextElementSibling;
    if (itemPanel) itemPanel.style.maxHeight = null;
  });

  if (shouldOpen) {
    header.classList.remove('collapsed');
    header.setAttribute('aria-expanded', 'true');
    if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
  }
}

    onBodyClickEvent(event) {
      if (!this.filterDropdown) return;
      if (event.target.closest('[data-faqs-filter]')) return;

      this.filterDropdown.classList.remove('is-show');

      if (this.filterDropdownArrow) {
        this.filterDropdownArrow.classList.remove('active');
      }
    }
  }

  customElements.define('faqs-item', FAQs);
})();